/**
 * Converts empty strings to `null` for dynamic module / Formily payloads.
 * Many backends reject `""` for optional cleared fields and expect `null`.
 */
export const normalizeEmptyStringsToNull = <T extends Record<string, unknown>>(
  payload: T
): T => {
  const out = { ...payload } as Record<string, unknown>;
  for (const key of Object.keys(out)) {
    const v = out[key];
    if (v === "") {
      out[key] = null;
      continue;
    }
    if (typeof v === "string" && v.trim() === "") {
      out[key] = null;
    }
  }
  return out as T;
};
